import React from 'react';
import PropTypes from 'prop-types';
import MasterConfigSection from './MasterConfigSection';
import SlaveConfigSection from './SlaveConfigSection';
import LogicConfigSection from './LogicConfigSection';
import WifiConfigSection from './WifiConfigSection';
import DeviceIdConfigSection from './DeviceIdConfigSection';

const UnifiedConfigCard = ({
  masterConfig,
  setMasterConfig,
  slaveConfig,
  setSlaveConfig,
  onSendMaster,
  onSendSlave,
  onSendWifi,
  onSendDeviceId,
  sending,
  selectedLocalId,
}) => {
  const masterHardwareConfig = masterConfig.hardware || {};
  const masterLogicConfig = masterConfig.logic || {};
  const slaveHardwareConfig = slaveConfig.hardware || {};

  const handleHardwareChange = (target, key, value) => {
    const applyVolumeSync = (hardware) => {
      if (key !== 'buzzer_alarm_volume') return hardware;
      return {
        ...hardware,
        buzzer_warning_volume: value,
        buzzer_ui_volume: value,
        speaker_volume: value,
      };
    };

    if (target === 'master') {
      setMasterConfig((prev) => {
        const nextHardware = applyVolumeSync({ ...(prev.hardware || {}), [key]: value });
        return { ...prev, hardware: nextHardware };
      });
      return;
    }
    setSlaveConfig((prev) => {
      const nextHardware = applyVolumeSync({ ...(prev.hardware || {}), [key]: value });
      return { ...prev, hardware: nextHardware };
    });
  };

  const handleLogicChange = (key, value) => {
    setMasterConfig((prev) => ({
      ...prev,
      logic: { ...(prev.logic || {}), [key]: value },
    }));
  };

  return (
    <div className="card section-card config-preview-card">
      <div className="card-header py-2 px-3 border-bottom config-preview-card-header">
        <h5 className="mb-0 text-dark text-uppercase font-weight-bold config-preview-card-title text-center">
          Configuración de Lectoras
        </h5>
      </div>
      <div className="card-body config-preview-card-body">
        <div className="row align-items-start mx-0">
          <div className="col-12 col-xl-6 border-right">
            <MasterConfigSection
              masterHardwareConfig={masterHardwareConfig}
              onHardwareChange={handleHardwareChange}
              sending={sending}
            />

            <LogicConfigSection
              masterLogicConfig={masterLogicConfig}
              onLogicChange={handleLogicChange}
              sending={sending}
            />

            <WifiConfigSection
              onSendWifi={onSendWifi}
              sending={sending}
              disabled={!selectedLocalId}
            />

            <DeviceIdConfigSection
              onSendDeviceId={onSendDeviceId}
              sending={sending}
              disabled={!selectedLocalId}
            />

            <div className="text-center py-2 mt-3">
              <button
                className="btn btn-admin-button active btn-send-config"
                disabled={!selectedLocalId || sending}
                onClick={onSendMaster}
              >
                {sending ? 'Enviando...' : 'Enviar a Maestra'}
              </button>
            </div>
          </div>

          <div className="col-12 col-xl-6">
            <SlaveConfigSection
              slaveHardwareConfig={slaveHardwareConfig}
              onHardwareChange={handleHardwareChange}
              sending={sending}
            />

            <div className="text-center py-2 mt-3">
              <button
                className="btn btn-admin-button active btn-send-config"
                disabled={!selectedLocalId || sending}
                onClick={onSendSlave}
              >
                {sending ? 'Enviando...' : 'Enviar a Esclava'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UnifiedConfigCard.propTypes = {
  masterConfig: PropTypes.object.isRequired,
  setMasterConfig: PropTypes.func.isRequired,
  slaveConfig: PropTypes.object.isRequired,
  setSlaveConfig: PropTypes.func.isRequired,
  onSendMaster: PropTypes.func.isRequired,
  onSendSlave: PropTypes.func.isRequired,
  onSendWifi: PropTypes.func.isRequired,
  onSendDeviceId: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  selectedLocalId: PropTypes.string.isRequired,
};

export default UnifiedConfigCard;
